import { createClient } from "@prismicio/client"
import { PrismicConfig } from "./Config"

export const PrismicV7Client = createClient("sixty-six-north-dev", {
  accessToken: PrismicConfig.accessToken
})
